<template>

  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader :title="$t('accountsTransfers.accountsTransfersOprations')"
                     :description="$t('accountsTransfers.fromHereYouControlTransferYourAccounts')"/>
         <indexTable :searchText="$t('accountsTransfers.searchTransfer')"
                     :emptyTableText="$t('safesTransfers.thereAreNoWithdrawalsOperations')"
                     :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
                     :buttonRole="$user.role.accounts_transfers_add"
                     :statusSearch="true"
                     :statusValues="[
                        { title: $t('orders.situation'), value: ''},
                        { title: $t('orders.all'), value: ''},
                        { title: $t('invoices.draft'), value: 0 },
                        { title: $t('invoices.approved'), value: 1 },
                     ]"
                     :cloumns="[
                         {column: 'code',    title: $t('accountsTransfers.operationCode') ,type: 'mainLink' , sort: true },
                         {column: 'date',    title: $t('accountsTransfers.date') ,type: 'text' , sort: true },
                         {column: 'to_client_type',    title: $t('accountsTransfers.formAccount'),type: 'toClintLink', sort: true},
                         {column: 'from_client_type',    title: $t('accountsTransfers.toAccount'),type: 'fromClintLink', sort: true},
                         {column: 'cost',    title: $t('safesTransfers.amount') ,type: 'text' , sort: true },
                         {column: 'status', title: $t('bills.situation') ,type: 'status' , sort: true ,  values: [
                              {title: $t('invoices.draft'), value: 0, color: 'dark'},
                              {title: $t('invoices.approved'), value: 1, color: 'success'},
                            ]
                         },
                         {column: 'options', title: $t('safesTransfers.settings'), type: 'options', options: [
                             {name: 'show'},
                             {name: 'edit',   role: $user.admin || $user.role.accounts_transfers_edit},
                             {name: 'file'},
                             {name: 'delete', role: $user.admin || $user.role.accounts_transfers_delete},
                         ]}
                       ]"
                     :deleteText="{
                        attention: $t('allerts.Attention'),
                        areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
                        close: $t('allerts.close'),
                        confirm: $t('allerts.confirm'),
                        loading: $t('allerts.loading'),
                       }" />
      </div>
    </div>
  </div>

</template>
<script>

  import indexHeader from '../elements/index/indexHeader.vue'
  import indexTable from '../elements/index/indexTable.vue'

  export default {
    data() {
      return {
        path: '/accountsTransfers',
      }
    },
    components: {
      indexHeader,
      indexTable,
    }
  }

</script>
